export const USER_KEY = "certa.user" as const;
export const LANGUAGE_KEY = "certa.preferredLanguage" as const;
export const EMBED_VIEW_KEY = "certa.isEmbeddedView" as const;
export const HIDE_COMMENTS_KEY = "certa.hideCommentsIcon" as const;
export const EXIT_IFRAME_KEY = "certa.exitIframeButton" as const;
